import { Link } from "react-router-dom";
import EchoLogo from "./EchoLogo";

const FOOTER_LINKS = [
  { label: "Politique de confidentialité", href: "/politique", testid: "footer-privacy" },
  { label: "Conditions d'utilisation", href: "/conditions", testid: "footer-terms" },
  { label: "Mentions légales", href: "/mentions", testid: "footer-legal" },
  { label: "À Propos d'Echo", href: "/propos", testid: "footer-about" },
  { label: "Support", href: "/support", testid: "footer-support" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-16 pb-10 border-t border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <Link to="/" className="flex items-center gap-3" data-testid="footer-logo">
            <EchoLogo size={32} testid="footer-logo-icon" />
            <span className="text-white font-bold text-lg tracking-tight">Echo</span>
          </Link>

          <nav className="flex flex-wrap items-center gap-x-6 gap-y-3">
            {FOOTER_LINKS.map((link) => (
              <Link
                key={link.label}
                to={link.href}
                data-testid={link.testid}
                className="text-sm text-white/50 hover:text-white transition-colors duration-300 font-medium"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-10 pt-8 border-t border-white/[0.05] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs sm:text-sm text-white/40 font-medium" data-testid="footer-copyright">
            © {new Date().getFullYear()} Echo — Tous droits réservés.
          </p>
          <p className="text-xs sm:text-sm text-white/40 font-medium">
            Fait avec soin en France 🇫🇷
          </p>
        </div>
      </div>
    </footer>
  );
}
